import { EVENTS, PHOTO_SEARCH } from "../../helpers/constants/url";
import baseApi from "./baseApiEndpoints";

// Define a service using a base URL and expected endpoints
export const aiApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhotoSearches: builder.query({
      query: () => `${PHOTO_SEARCH}`,
      providesTags: ["AI"],
    }),
    createSearchRequest: builder.mutation({
      query: (event) => ({
        url: `${PHOTO_SEARCH}`,
        method: "POST",
        body: event,
      }),
      invalidatesTags: ["AI"]
    }),
  }),
  overrideExisting: false,
});

export const { useGetPhotoSearchesQuery, useCreateSearchRequestMutation } = aiApi;
